import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import { vegetablesFull } from 'components/ProductItems/mockData';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import bannerImage from 'images/trial-results-banner.jpg';
import { trialResults } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const TrialResults = () => {
    const data = [...vegetablesFull].reverse();

    return (
        <>
            <Banner title="Trial results" image={bannerImage} buttonText="View results" />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            We showcase the results <br /> of our <img src={image} alt="decor" />
                            <em>research on different groups of plants</em>
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Here you can find <em>analyzes and conclusions</em> on the effectiveness of products in
                                increasing yields.
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={trialResults} />}>
                    <div className="box">
                        <ProductItems data={data} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default TrialResults;
